/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Existing feedback sentiment recorded for this block, when any.
 */
export const RiskBlockFeedback = {
  Up: "up",
  Down: "down",
} as const;
/**
 * Existing feedback sentiment recorded for this block, when any.
 */
export type RiskBlockFeedback = OpenEnum<typeof RiskBlockFeedback>;

export type RiskBlock = {
  /**
   * When the block occurred.
   */
  createdAt: Date;
  /**
   * Existing feedback sentiment recorded for this block, when any.
   */
  feedback?: RiskBlockFeedback | undefined;
  /**
   * The block ID (the underlying risk result ID).
   */
  id: string;
  /**
   * Name of the risk policy that blocked the call.
   */
  policyName: string;
  /**
   * The project the block belongs to.
   */
  projectId: string;
  /**
   * Agent surface that reported the blocked call (adapter slug, e.g. "openclaw"), when known.
   */
  provider?: string | undefined;
  /**
   * Human-readable reason the tool call was blocked.
   */
  reason: string;
  /**
   * Name of the tool that was blocked, when known.
   */
  toolName?: string | undefined;
};

/** @internal */
export const RiskBlockFeedback$inboundSchema: z.ZodMiniType<
  RiskBlockFeedback,
  unknown
> = openEnums.inboundSchema(RiskBlockFeedback);

/** @internal */
export const RiskBlock$inboundSchema: z.ZodMiniType<RiskBlock, unknown> = z
  .pipe(
    z.object({
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      feedback: z.optional(RiskBlockFeedback$inboundSchema),
      id: z.string(),
      policy_name: z.string(),
      project_id: z.string(),
      provider: z.optional(z.string()),
      reason: z.string(),
      tool_name: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "created_at": "createdAt",
        "policy_name": "policyName",
        "project_id": "projectId",
        "tool_name": "toolName",
      });
    }),
  );

export function riskBlockFromJSON(
  jsonString: string,
): SafeParseResult<RiskBlock, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskBlock$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskBlock' from JSON`,
  );
}
